"use client";

import { ReactNode } from "react";

interface BaseHeroProps {
  title: string | ReactNode;
  description: string | ReactNode;
  bgImageSm?: string;
  bgImageLg?: string;
  className?: string;
  headingClassName?: string;
  descriptionClassName?: string;
}

export default function BaseHero({
  title,
  description,
  className = "",
  headingClassName = "",
  descriptionClassName = "",
  bgImageSm = "",
  bgImageLg = "",
}: BaseHeroProps) {
  return (
    <section
      className={
        `bg-cover bg-center min-h-[280px] lg:min-h-[468px] flex ${className} ` +
        (bgImageSm ? ` ${bgImageSm}` : "") +
        (bgImageLg ? ` ${bgImageLg}` : "")
      }
    >
      <div className="w-full max-w-8xl mx-auto">
        <div className="mx-2 flex flex-col p-4 pb-6 md:p-6 lg:p-8 justify-between h-full">
          <div className="flex flex-col justify-between h-full">
            <h1
              className={`text-[50px] lg:text-[70px] xl:text-[104px] max-w-sm lg:max-w-md xl:max-w-[52rem] font-medium text-white tracking-tighter leading-none ${headingClassName}`}
            >
              {title}
            </h1>
            <p
              className={`text-white text-[17px] lg:text-xl xl:text-2xl leading-5 lg:leading-tight max-w-xs lg:max-w-sm xl:max-w-md ${descriptionClassName}`}
            >
              {description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
